import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ctaContent, images, siteConfig } from '../../data/mock';

gsap.registerPlugin(ScrollTrigger);

const CTA = () => {
  const sectionRef = useRef(null);
  const bgRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Zoom effect on scroll
      gsap.fromTo(
        bgRef.current,
        { scale: 1 },
        {
          scale: 1.1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        '.cta-animate',
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 60%',
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-40 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          ref={bgRef}
          src={images.ctaBg}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1121] via-[#0B1121]/80 to-[#0B1121]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 l-container">
        <div className="max-w-2xl">
          {/* Logo */}
          <img 
            src="/favicon.png" 
            alt="Qasaba Energy" 
            className="w-16 h-16 mb-8 cta-animate object-contain"
          />

          <p className="font-serif text-3xl lg:text-4xl text-white leading-tight mb-10 cta-animate">
            {ctaContent.text}
          </p>

          <a
            href={`mailto:${siteConfig.email}`}
            className="site-link site-link--white cta-animate"
          >
            {ctaContent.cta}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
